export default "__VITE_ASSET__DGZronZW__"